import {formatISO} from "date-fns";
import IdentityService from "../../../../services/IdentityService";





export default class LookupEntityManager 
{


    static  findCard(schema, cardId)
    {
        var lCardId = cardId.toLowerCase();
        var result = null;
        for (var i=0; i<schema.categories.length; i++)
        {
            var category = schema.categories[i];
            for (var j=0; j<category.groups.length; j++)
            {
                var group = category.groups[j];
                if (group.cards.some((card) => card.id.toLowerCase() === lCardId))
                {
                    var result = group.cards.find((card) => card.id.toLowerCase() === lCardId);
                    return result;
                }
            }
        }
    }

    static getLookupEntityCardSchema(schema, entityLookupKeyId)
    {
        var entityIdCard = LookupEntityManager.findCard(schema, entityLookupKeyId);
        var result = entityIdCard.lookupEntity;
        return result;
    }

    static getEntitySchemaFromSchema(schema, entityLookupKeyId, entityKeyCardReadOnly)
    {
      // get the entityKey card;
      var entityIdCard = LookupEntityManager.findCard(schema, entityLookupKeyId);
      if (entityKeyCardReadOnly)
      {
        entityIdCard.fieldType = "readonly";
      }
      else 
      {
        entityIdCard.fieldType = "text"; // we do NOT want it to show the lookup info
      }
      // if (!entityIdCard) // what do we do?
      var entitySchema = {};
      entitySchema.schemaInfo = schema.schemaInfo;
      entitySchema.categories = [];
      var lookupCategory = {
        id: "lookupEntity",
        "title": "Lookup Entity Editor",
        "initEnabled": true
      };
      lookupCategory.groups = [];
      var idGroup = {
        groupTitle: "Entity Key",
        cards: [entityIdCard]
      };
      var lookupGroup = {
        groupTitle: "Lookup Values",
        cards: []
      }
      lookupCategory.groups.push(idGroup);
  
      entityIdCard.lookupEntity.valueIds.forEach((lCardId) => 
      {
        var lookupValueCard = LookupEntityManager.findCard(schema, lCardId);
        lookupGroup.cards.push(lookupValueCard);
      });
      lookupCategory.groups.push(lookupGroup);
  
      entitySchema.categories.push(lookupCategory);
      return entitySchema;
    }

    static toLookupEntityList(saveEntityBag, valueBag, schema, gcid, uid)
    {
        var schemaLookupEntities = {};
        schema.categories.forEach((cat) => 
        {
            cat.groups.forEach((group) => 
            {
              group.cards.forEach((card) => 
              {
                if (card.lookupEntity)
                {
                    schemaLookupEntities[card.id] = card.lookupEntity;
                }
              });
            });
        });

        var result = [];
        Object.keys(saveEntityBag).forEach((key) => 
        {
            if (schemaLookupEntities[key])
            {
                var entityData = [];
                schemaLookupEntities[key].valueIds.forEach((v) => 
                {
                    entityData.push({Id: v, Value: valueBag[v]});
                });
            }
            var id = (valueBag.id) ? valueBag.id : IdentityService.makeUuid();
            var entity = 
            {
                MetaData: 
                {
                    Id: id,
                    EntityType: key,
                    SchemaId: schema.schemaInfo.id,
                    EntityKey: valueBag[key],
                    Gcid: gcid, 
                    Description: "",
                    LastUpdated: formatISO(new Date()),
                    LastUpdatedBy: uid,
                    LastUpdatedNote: "generated from observation",
                    IsActive: true
                },
                Data: entityData
            }
            result.push(entity);
        })

        return result;


    }




}


